<template>
  <div class="container">
    <router-link class="link" to="/terms">Terms of Service</router-link>
    <span class="bullet">&#8226;</span>
    <a href="mailto:contact@numer.ai" class="link" @click="contact"
      >Contact Us</a
    >
  </div>
</template>

<script>
export default {
  data: () => ({
    icons: ['mdi-home', 'mdi-email', 'mdi-calendar', 'mdi-delete'],
  }),
  computed: {},
  methods: {
    toTerms() {
      this.$router.push('/terms')
    },
    contact() {
      parent.location = 'mailto:contact@numer.ai'
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  text-align: center;
  color: var(--color-subtle);
}
.bullet {
  padding: 0 0.4em;
}
.link {
  color: var(--color-subtle);
  text-decoration: none;
}
.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
